'use strict';

var constant = function constant(a) {
    return function () {
        return a;
    };
};

/**
 * render template with data
 *
 * @param templ
 * @param data
 */

module.exports = function (templ, data) {
    check(templ, data);

    var result = templ;

    var replace = function replace(key) {
        var name = '{{ ' + key + ' }}';
        var str = constant(data[key]);

        while (~result.indexOf(name)) {
            result = result.replace(name, str);
        }
    };

    Object.keys(data).forEach(replace);

    if (~result.indexOf('{{')) result = result.replace(/{{.*?}}/g, '');

    return result;
};

function check(templ, data) {
    if (typeof templ !== 'string') throw Error('template should be a string!');

    if (typeof data !== 'object') throw Error('data should be an object!');
}